import React from "react";
import Popup from "reactjs-popup";

const PopupConfirmation = ({
  className = "",
  title,
  content,
  trigger,
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
}) => {
  return (
    <div className="PopupConfirmation">
      <Popup trigger={trigger} modal closeOnDocumentClick={false} className={"fade-in popup-md " + className}>
        {(close) => (
          <div>
            <div className="d-flex flex-row mb-3">
              <div className="flex-grow-1">
                <h2 className="text-white">{title}</h2>
              </div>
              <div className="flex-grow-0">
                <button className={"btn"} onClick={close}>
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>

            <div className="m-1 mb-3">{content}</div>

            <div className="d-flex justify-content-end gap-2">
              <button className="btn btn-secondary" onClick={close}>
                {cancelText}
              </button>
              <button
                className="btn btn-info"
                onClick={() => {
                  onConfirm();
                  close();
                }}
              >
                {confirmText}
              </button>
            </div>
          </div>
        )}
      </Popup>
    </div>
  );
};

export default PopupConfirmation;
